// NATIVE

// INSTALLED
import { Tab } from '@mui/material';

// CUSTOM

/**
 * CustomButtonTab is a styled Tab component with customized styles for different states.
 *
 * @param {any} props - The properties passed to the Tab component.
 *
 * @returns {JSX.Element} A Tab component with custom styles applied.
 *
 * @example
 * <CustomButtonTab label="Tab 1" />
 *
 * @component
 */
export const CustomButtonTab = (props: any) => {
  return (
    <Tab
      {...props}
      sx={{
        marginRight: 1,
        textTransform: 'none',
        boxShadow: 'inherit',
        padding: '0.5rem 16px !important',
        minHeight: 1,
        borderRadius: 2,
        fontWeight: 700,
        color: '#403A4F',
        '&.Mui-selected': {
          backgroundColor: 'primary.main',
          color: '#fff',
        },
        '&:hover': {
          backgroundColor: '#E4DCFB',
          color: '#9857FF',
        },
      }}
    />
  );
};

export default CustomButtonTab;
